var map;
var idMunicipalite = null;

var newWindow;
var myBbox;
var myProperties;
var maxRecherche = 50;

function init_explorateur_ue_partage() {

    // Ceci permet entre autre de charger le listbox de voies publiques selon la municipalité
    var selecteur = $('#wizard').attr('id-municipalite');
    if (selecteur != '' && !!selecteur) {
        var idMunicipalite = selecteur;
        ouvrirRechercheExpUe(idMunicipalite);
    }

    initExpUeProprietaireSelect2();

    // Numéric seulement
    $(".digit-only").keypress(function (e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            //  Display error message
            //  $("#exp-ue-id-ue-errmsg").html("Seulement des nombres").show().fadeOut(1000);
            return false;
        }
    });

    $(".execute-recherche").keypress(function (e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which == 13) {
            $('#exp-ue-nouvelle-recherche').trigger('click');
            return false;
        }
    });

    function expUeGetCriteresRecherche() {
        var params = {};
        params.idUe = $('#exp-ue-id-ue').val();
        params.matricule = $('#exp-ue-id-matricule').val().replace(/-_.*$/g, '');


        params.lot = $('#exp-ue-lot').val().replace(/\s+/g, '');
        params.proprietaire = $('#exp-ue-proprietaire').val();

        // On obtient la municipalité soit de l'Explorateur ou soit de l'Assistant
        params.idMunicipalite = '';
        var idMunicipalite = $('#wizard').attr('id-municipalite');
        if (idMunicipalite) {
            params.idMunicipalite = idMunicipalite;
        }
        else {
            var listbox = $('#exp-ue-liste-ville').length;
            if (listbox > 0) {
                params.idMunicipalite = $('#exp-ue-liste-ville').val();
            }
        }

        params.voiePublique = null;
        if ($('#voie-publique').val() != 0) {
            params.voiePublique = $('#voie-publique').val();
        }

        params.noCivique = null;
        if ($('#no-civique').val() != 0) {
            params.noCivique = $("#no-civique option:selected").val();
        }

        // #11023
        params.noBail = $('#exp-ue-id-bail').val();
        // #17228
        params.noReference = $('#exp-ue-no-reference').val();
        // importgat
        params.noDossierAncien = $('#exp-ue-no-dossier-ancien').val();
        params.noCertificat= $('#exp-ue-no-certificat').val();

        params.idBatiment = $('#exp-ue-id-batiment').val();

        params.rechercherHistorique = $('#exp-ue-rechercher-historique').prop('checked');
        params.dateEvenement = moment().format('YYYY-MM-DD');

        return params;
    }

    $('#exp-ue-nouvelle-recherche').off('click').on('click', function (e) {

        $('#div-resultat').html('');
        viderInfosMutation();

        var params = expUeGetCriteresRecherche();
        // # 11023
        expUeExecuterRecherche(params.idMunicipalite, params.idUe, params.idBatiment, params.matricule, params.lot, params.proprietaire,
            params.voiePublique, params.noCivique, params.dateEvenement, false, params.rechercherHistorique, params.noBail, params.noReference,
            params.noDossierAncien, params.noCertificat);

        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
    });


    $('#exp-ue-ajouter-recherche').off('click').on('click', function (e) {

        var params = expUeGetCriteresRecherche();
        expUeExecuterRecherche(params.idMunicipalite, params.idUe, params.idBatiment, params.matricule, params.lot, params.proprietaire,
            params.voiePublique, params.noCivique, params.dateEvenement, true, params.rechercherHistorique, params.noBail, params.noReference,
            params.noDossierAncien, params.noCertificat);

        fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
    });

    $('#modal-recherche #exp-ue-vider').off('click').on('click', function (e, clear_div_resultat) {
        if (clear_div_resultat == 'oui' || clear_div_resultat == undefined) {
            $('#div-resultat').html('');
            viderInfosMutation();
        }

        $('#exp-ue-id-ue').val('');
        $('#exp-ue-id-matricule').val('');
        $('#exp-ue-proprietaire').select2('val', '');
        $('#exp-ue-lot').val('');

        $('#exp-ue-id-batiment').val('');
        $('#exp-ue-id-bail').val('');

        $('#voie-publique').select2("val", "");

        $('#no-civique').find('option').remove().end();
        $('#no-civique').append('<option value=""></option>');
        $('#no-civique').select2();

        $('#exp-ue-no-reference').val('');

        //var nbElement = 0;
        $('#exp-ue-recherche-nb').text($('#div-resultat > div').length + ' élément(s)');
        $('#exp-ue-recherche-nb').removeClass("red");

        $('#exp-ue-rechercher-historique').removeAttr('checked');
        // #9176 On doit aussi réinitialiser la liste des voies publiques sinon, on fait une recherche historique, on vide les résultats et une voie publique désactivée apparaît toujours. David avait repéré le même comportement pour exp-ue-rechercher-historique
        idMunicipalite = $('#wizard').attr('id-municipalite');
        if (!idMunicipalite) {
            var listbox = $('#exp-ue-liste-ville').length;
            if (listbox > 0) {
                idMunicipalite = $('#exp-ue-liste-ville').val();
            }
        }

        chargerVoiePubliqueExpUe(idMunicipalite, $('#voie-publique'), null, null, function (e) {
            $('#voie-publique').change();
        });


    });

    $('#exp-ue-transferer').off('click').on('click', function () {
        if($('#explorateur_ue_accordeons').hasClass('hidden')) {
            $('#explorateur_ue_accordeons').removeClass('hidden');
            $('#explorateur_ue_warning').addClass('hidden');
        }

        var unitesEvaluation = $('#div-resultat').find('.list-group-item');
        $.each(unitesEvaluation, function (idx, value) {
            var idUe = $(value).attr('id-ue');
            var matricule = $(value).attr('id-matricule');

            var params = {
                "matricule": matricule
            };

            myProperties = params;

            var municipalite = $(value).attr('id-mun');

            var adresse = $(this).find('p').text();
            adresse = adresse.substr(0, adresse.indexOf(','));
            var dateEvenement = $(value).attr('date-evenement');

            var is_in = true;
            $('#div-resultat-historique').find('a').each(function () {
                var idHisto = $(this).attr('id-ue');
                if (idUe == idHisto) {
                    is_in = false;
                }
            });

            if (is_in) {
                var historiqueDivString = getDivHistoriqueString(idUe, municipalite, municipalite, matricule, adresse, dateEvenement);
                $('#div-resultat-historique').prepend(historiqueDivString);
            }

        });

        unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
        if (unitesEvaluation.length > 0)
        {
            $('#div-resultat-historique-nb').text($('#div-resultat').find('.list-group-item').length);
            $('#btn-generer-pdf').prop('disabled', false);
            $('#btn-exp-assigner-evenement').prop('disabled', false);
        }

    });

    // le click sur le checkbox fait 2 fois click sur le lien('a'), donc, ici on bloque le 2e clique et on coche la case
    $('#div-resultat').off('click', '.checkbox [name="id_ue"]').on('click', '.checkbox [name="id_ue"]', function (e) {
        if($(this).attr('type')!='radio'){
            $(this).prop("checked", !$(this).is(':checked'));
        }
        e.stopPropagation();
    });

    $('#div-resultat').off('click', 'a').on('click', 'a', function (e) {

        if ($('#modal-wizard-evenement').length) { // Sélection des unités d'évaluations dans la Tenue à jour

            var checkboxEstCoche = false;
            var idUeCliquee = $(this).attr('id-ue');

            var boutonX = $(e.target).closest('button');
            if (boutonX.length) {
                boutonX.closest("#" + idUeCliquee + "_div").remove();
                $('#exp-ue-recherche-nb').text($('#div-resultat > div').length + ' élément(s)');
                $('.banniere').remove(); //pour eviter de desactiver la close de la banniere
            }
            else {
                var checkbox_ou_radio = $(this).find("input[type='checkbox'], input[type='radio']");
                checkbox_ou_radio.prop("checked", !checkbox_ou_radio.is(':checked'));
                checkboxEstCoche = checkbox_ou_radio.prop("checked");
                $(this).css('background-color', checkboxEstCoche ? '#dff0d8' : "white");
            }

            var typeEvenement = $('#wizard').attr('id-type-evenement');
            if (typeEvenement == TYPE_EVENEMENT.mutation) {

                var listeIdUes = [];
                // avoir la liste de ues cochées
                var ueCochees = $('[name="id_ue"]:checked');
                $.each(ueCochees, function () {
                    listeIdUes.push(parseInt($(this).closest('a').attr('id-ue')));
                });
                var params = {
                    id_ue: checkboxEstCoche ? idUeCliquee : '',
                    liste_id_ue: JSON.stringify(listeIdUes),
                    date_evenement: $('#wizard').attr('date-evenement'),
                    id_processus: $('#wizard').attr('id-processus')
                };

                var containerUeLots = $('#exp-ue-lots');
                $.ajax({
                    url: '/gestion-roles/exp-ue/ue-lots/',
                    async: false,
                    data: params,
                    dataType: 'json',
                    success: function (response) {

                        if (checkboxEstCoche) {
                            containerUeLots.append(response.ue_lots_html);

                            // # 11441
                            if (response.ue_lots_html == '\n\n\n') {
                                $('#accordion-mutation-lots-ue-impliques').remove();
                            }

                            // utiliser pour la liste des lots de ue
                            initCheckboxTous($('#checkbox-ue-lot-tous'), $('[name="bool_lot_inclus"]'));

                            $('[name="bool_lot_inclus"]').off('change').on('change', function () {
                                $(this).closest('[id="mutation-ue-lots"]').attr('modifie', 'True');
                                $('#localisation-ue-infos-mutation').attr('modifie', 'True');
                            });
                        }
                        else {
                            containerUeLots.find('[name="lot_id_ue"]').filter(function () {
                                if ($(this).text() == idUeCliquee) {
                                    $(this).closest('#mutation-ue-lots').remove();
                                }
                            });
                        }
                        erreursAjax.effacerErreurChamps($('#localisation-ue-resultat-recherche-mutation'));
                        if (response.erreur_meme_proprio_meme_pourcentage) {
                            erreursAjax.afficherErreurChamps($('#localisation-ue-resultat-recherche-mutation'), 'none', response.erreur_meme_proprio_meme_pourcentage, '');
                        }

                        $("#afficher-warning-cadastre-vertical-etape-2").toggle(response.est_cadastre_vertical_etape_2);
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        erreursAjax.traiterErreurs($('#ue-lots-ue-impliques'), xhr, thrownError);
                        $('.tooltip').remove();

                        // response.status = 'error';
                    }
                });

                // voir le prix ventilé des ues sélectionnées
                var containerMutationMultiplesUes = $('#mutation-multiples-ues');

                $.ajax({
                    url: '/gestion-roles/exp-ue/mutation-multiples-ues/',
                    async: false,
                    data: params,
                    dataType: 'html',
                    success: function (response) {

                        if (checkboxEstCoche) {

                            containerMutationMultiplesUes = $('#mutation-multiples-ues');
                            containerMutationMultiplesUes.append(response);

                            initMultiplesUesMutation();

                            formaterMonnaie($('#modal-wizard-evenement').find('input.money'), 0);
                        }
                        else {
                            containerMutationMultiplesUes.find('[name="uniteEvaluation"]').filter(function () {
                                if ($(this).text() == idUeCliquee) {
                                    $(this).closest('#mutation-multiples-ues-form').remove();
                                }
                            });
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        erreursAjax.traiterErreurs($('#ue-lots-ue-impliques'), xhr, thrownError);
                        $('.tooltip').remove();

                        // response.status = 'error';
                    }
                });
            }
            else if (typeEvenement == TYPE_EVENEMENT.demande_de_revision) {
                // On a cliqué sur un élément de la liste des résultats de recherche d'UEs
                let element_a_clique = this; // element <a>
                revisionsAdministrativesModal.callbackSelectionUEpourDDR(element_a_clique, e, checkboxEstCoche);
            }
            else if (typeEvenement == TYPE_EVENEMENT.recours_au_tribunal) {
                let element_a_clique = this;
                revisionsAdministrativesModal.callbackSelectionUEpourRAT(element_a_clique, e, checkboxEstCoche);
            }
            else if (typeEvenement == TYPE_EVENEMENT.correction_d_office) {
                let element_a_clique = this;
                revisionsAdministrativesModal.callbackSelectionUEpourCDO(element_a_clique, e, checkboxEstCoche);
            }
        } else {

            //rafraichir les donnees
            var idUe = $(this).attr('id-ue');

            var municipalite = $(this).attr('id-mun');
            var matricule = $(this).attr('id-matricule');

            var adresse = $(this).find('p').text();
            adresse = adresse.substr(0, adresse.indexOf(','));

            var dateEvenement = $(this).attr('date-evenement');

            var historiqueDivString;
            // si la municipalité (liste déroulante) est différente de celle dans le résultat de recherche
            if (municipalite != idMunicipalite) {
                historiqueDivString = getDivHistoriqueString(idUe, municipalite, municipalite, matricule, adresse, dateEvenement);

                var params = {
                    "matricule": matricule
                };

                myProperties = params;
                //ajoute à l'historique en épurant

                if ($('#div-resultat-historique').is(':empty')) {
                    $('#div-resultat-historique').prepend(historiqueDivString);
                } else {

                    var is_in = true;
                    $('#div-resultat-historique').find('a').each(function () {
                        var idHisto = $(this).attr('id-ue');
                        if (idUe == idHisto) {
                            is_in = false;
                        }
                    });

                    if (is_in) {
                        $('#div-resultat-historique').prepend(historiqueDivString);
                    }

                }

                // on déclanche le click sur l'unité d'évaluation qui vient juste d'être ajouter
                var unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
                $.each(unitesEvaluation, function (idx, value) {
                    var ueSelected = $(value).attr('id-ue');
                    if (idUe == ueSelected) {
                        $(value).trigger('click');
                    }
                });

                $("#exp-ue-liste-ville").select2("val", municipalite);

                //fermer la fenetre modal
                $('#btn-close-modal-recherche').trigger('click');
                return false;


            } else {
                historiqueDivString = getDivHistoriqueString(idUe, municipalite, idMunicipalite, matricule, adresse, dateEvenement);

                expUegetInfoUe(idMunicipalite, matricule, dateEvenement, idUe);

                //ajoute à l'historique en épurant
                if ($('#div-resultat-historique').is(':empty')) {

                    $('#div-resultat-historique').prepend(historiqueDivString);

                } else {

                    var is_in = true;
                    $('#div-resultat-historique').find('a').each(function () {
                        var idHisto = $(this).attr('id-ue');
                        if (idUe == idHisto) {
                            is_in = false;
                        }
                    });

                    if (is_in) {
                        $('#div-resultat-historique').prepend(historiqueDivString);
                    }

                }

                //zoomer sur l'entite
                zoomToSelect(matricule.substring(0, 12));

                //fermer la fenetre
                $('#btn-close-modal-recherche').trigger('click');
                return false;

            }

        }
    });
}

function getDivHistoriqueString(idUe, municipalite, idMunicipalite, matricule, adresse, dateEvenement) {
    if (idUe != 'None') {
        return '<div id="' + idUe + '_div"><a  href="#" class="list-group-item" id-mun="' + municipalite + '" id-matricule="' + matricule + '" id-ue="' + idUe + '" date-evenement="' + dateEvenement + '"><i id="' + idUe + '-x" title="Retirer de l\'historique" style="color:#6FB3E0;"class="exp-ue-historique-recherche-liste ace-icon fa fa-lg fa-times icon-centered pull-right" ></i> <h4 class="list-group-item-heading text-bold text-red" style="font-size:11px !important;">' + matricule + '-' + idMunicipalite + '-' + idUe + '</h4><p class="list-group-item-text" style="font-size:10px">' + adresse + '</p></a></div>';
    }
}

// function pour l'autocomplete
function extractLast(term) {
    return split(term).pop();
}

// function pour l'autocomplete
function split(val) {
    return val.split(/,\s*/);
}


function ouvrirRechercheExpUe(idMunicipalite) {


    $("#exp-ue-id-ue").focus();

    var recharger;
    // si on est dans l'étape 2 de la mutation dans laquelle il y a les critères de recherche pour une ue, on force de recharger les noms de rues
    var idTypeEvenementWizard = $('#wizard').attr('id-type-evenement');
    if (idTypeEvenementWizard == '2') {
        recharger = 'oui';
    }
    else {
        recharger = $('#modal-recherche').attr('recharger');
    }

    if (recharger == undefined || recharger == 'oui') { //verifie s'il y a des rues de chargées afin d'éviter de charger à nouveau l'information

        // si on n'est pas dans la recherche de ues dans une mutation, on ne change pas le statut de rechargement du modal de recherche
        if (idTypeEvenementWizard != '2') {
            $('#modal-recherche').attr('recharger', 'non');
        }

        $('#voie-publique').select2();
        $('#no-civique').select2();

        masquesSelection.init();

        $('.input-mask-matricule').mask('9999-99-9999');
        // $('.input-mask-lot').mask('9 999 999');

        //idMunicipalite = $('#exp-ue-liste-ville').val();

        // charge les voie publique à l'ouverture de la fenêtre recherche, s'il ya déjà eu une ville de sélectionné
        if (idMunicipalite != null && idMunicipalite != '') {
            chargerVoiePubliqueExpUe(idMunicipalite);
        }

        // recharger les voies publiques si la case "Recherche dans l'historique" est coché
        $('#exp-ue-rechercher-historique').off('change').on('change', function () {
            // DM: finalement je crois qu'il faut recharger si on décoche, sinon des voies publiques resteront la meme s'ils n'ont pas d'affaire là
            //if ($(this).is(':checked')) {
            chargerVoiePubliqueExpUe(idMunicipalite, $('#voie-publique'), null, null, function (e) {
                // $('#voie-publique').change();
                $('#voie-publique').change();
            });
            //}
        });



        //charge les numéros civique en fonction de la voie publique sélectionné
        $('#voie-publique').off('change').on('change', function () { //chargement des numéros civique en function de la rue

            $('#no-civique').find('option').remove().end();
            $('#no-civique').append('<option value=""></option>');

            var voiePublique = $(this).val();
            if (voiePublique != '') {
                var dateEvenement = null;
                if ($('#wizard').attr('date-evenement')) {
                    dateEvenement = $('#wizard').attr('date-evenement');
                }
                var params = {date_evenement: dateEvenement};
                // on indique que la case "Recherche dans l'historique" est coché
                if ($('#exp-ue-rechercher-historique').is(':checked')) {
                    params.recharger_historique = true;
                }

                //ON CHARGE LES NRO CIVIQUE DE LA VOIE PUBLIQUE SÉLECTIONNÉE
                wait.start();

                $.ajax({
                    type: "GET",
                    url: "/gestion-roles/exp-ue/no-civique/municipalite/" + idMunicipalite + "/voie-publique/" + voiePublique + "/",
                    dataType: 'json',
                    data: params,
                    success: function (response) {

                        //On obtiens le résultats de la requet en format json
                        $.each(response, function (i, listNoCivique) {
                            // chargement des voie publiques dans le select
                            $('#no-civique').append($('<option>', {
                                value: listNoCivique.id_b00_adresse_ue,
                                text: listNoCivique.complet
                            }));
                        });

                        //$('#no-civique').select2("val", "");
                        wait.stop();
                    }
                });

            }
        });

        // load le matricule après 4 chiffres
        $("#exp-ue-id-matricule").bind("keydown", function (event) {
            if (event.keyCode === $.ui.keyCode.TAB &&
                $(this).autocomplete("instance").menu.active) {
                event.preventDefault();
            }
        }).autocomplete({
            source: function (request, response) {
                $.getJSON("/gestion-roles/exp-ue/maticule/", {
                    term: extractLast(request.term), "id_municipalite": idMunicipalite
                }, response);
            }, minLength: 4, //parametre pour definir la longueur avant l'execution de la requete

            focus: function () {
                // prevent value inserted on focus
                return false;
            },
            select: function (event, ui) {

                var terms = split(this.value);
                terms.pop();
                terms.push(ui.item.label);
                this.value = terms;
                return false;
            }
        });


        // execute la recherche
    }

    controlesFormulaires.clearable();
}

// # 11023
function expUeExecuterRecherche(idMunicipalite, idUe, idBatiment, matricule, lot, proprietaire, voiePublique, noCivique, dateEvenement, ajouter, rechercherHistorique, noBail, noReference, noDossierAncien, noCertificat) {


    var params = {
        "id_municipalite": idMunicipalite,
        "id_ue": idUe,
        "id_batiment": idBatiment,
        "matricule": matricule,
        "lot": lot,
        "proprietaire": proprietaire,
        "voie_publique": voiePublique,
        "no_civique": noCivique,
        // #11023
        "no_bail": noBail,
        // #17228
        "no_reference": noReference,
        "no_dossier_ancien": noDossierAncien,
        "no_certificat": noCertificat,
        "date_evenement": dateEvenement,
        "rechercher_historique": rechercherHistorique,
        "contexte": ($('#modal-wizard-evenement').length ? 'wizard' : '') // On n'affiche les cases à cocher dans les résultats de recherche que dans le contexte du wizard afin de sélectionner plusieurs UE ou bâtiments. Dans tous les autres cas, pour l'instant, cette sélection est individuelle.
    };

    let types_event_pour_radio = [
        TYPE_EVENEMENT.demande_de_revision,
        TYPE_EVENEMENT.recours_au_tribunal,
        TYPE_EVENEMENT.correction_d_office,
        TYPE_EVENEMENT.correction_erreur_ecriture,
    ];
    if(types_event_pour_radio.includes(Number($('div#wizard').attr('id-type-evenement')))){
        params['resultats_en_radio']=true;
    }

    if (idUe != '' || idBatiment != '' || matricule != '' || lot != '' || proprietaire != '' || voiePublique != null || noBail != null || noCertificat != '') {

        wait.start('div-resultat', '255,255,255', 1);
        $.ajax({
            type: "POST",
            url: "/gestion-roles/exp-ue/executer-recherche/",
            data: params,
            dataType: 'html',
            success: function (response) {

                if (response.length <= 200) {
                    //$('#aucun-resultat').html('').append(getBanniereMessage('', 'Aucune propriété ne correspond à votre recherche.'));
                    $('#exp-ue-recherche-nb').text('Aucune propriété ne correspond à votre recherche.');
                    $('#exp-ue-recherche-nb').addClass("red");
                    wait.stop('div-resultat');
                } else {

                    var nbrRecherche = $(response).find('#exp-ue-resultat-recherche-nb').val();
                    if (ajouter) {
                        $(response).find('a').each(function () {

                            var id = $(this).attr('id-ue');
                            if (!$("#" + id).length) {
                                // on insère seulement ceux qui ne sont pas déjà dans la liste
                                var is_in = true;
                                $('#div-resultat').find('a').each(function () {
                                    var idResultat = $(this).attr('id-ue');
                                    if (id == idResultat) {
                                        is_in = false;
                                    }
                                });
                                if (is_in) {
                                    $('#div-resultat').append($($.parseHTML(response)).filter('#' + $(this).parents(':eq(1)').attr("id")));

                                    // si un seul élément est trouvé, le sélectionner automatique
                                    // if (nbrRecherche == '1') {
                                    //     $('#div-resultat').find('a input[type=checkbox][name="id_ue"][value="' + id + '"]').closest('a').click();
                                    // }
                                }
                            }
                        });

                    } else {


                        $('#div-resultat').html('').append(response);


                        var elements = $('.step-pane.active #div-resultat').find('input[type=checkbox]');
                        var elementsChecked = elements.has(':checked');
                        if (elements.length == 1 && elementsChecked.length == 0) {
                            var typeEvenement = $('#wizard').attr('id-type-evenement');
                            if (typeEvenement == TYPE_EVENEMENT.mutation) {
                                elements.prop('checked', false);
                                elements.closest('a').click();

                            } else {
                                elements.prop('checked', true);
                            }

                        }

                        // si un seul élément est trouvé, le sélectionner automatique
                        // if (nbrRecherche == '1') {
                        //     $('.step-pane.active #div-resultat').find('input[type=checkbox]').closest('a').click();
                        // }
                    }
                    const rechercheMatriculeUnique = $('#exp-ue-resultat-recherche-matricule-unique').val() === "True";
                    if (nbrRecherche >= maxRecherche && !rechercheMatriculeUnique) {
                        $('#exp-ue-recherche-nb').text('Seulement les ' + maxRecherche + ' premiers sont affichés');
                        $('#exp-ue-recherche-nb').addClass("red");
                    } else {
                        var nbrResultats = $('#div-resultat').find('.list-group-item').length;
                        $('#exp-ue-recherche-nb').text(nbrResultats + ' élément(s)');
                        $('#exp-ue-recherche-nb').removeClass("red");
                    }
                    // retourne le nombre d'éléments
                    fenetreModal.calculerHauteurModal($('#modal-recherche'),'#modal-body-recherche');
                    wait.stop('div-resultat');
                    // s'il y a la municipalité dans l'étape, on met à jour la municipalité selon le dernier résultat de la liste de recherche
                    var municipaliteUeResultat = $(response).find('#exp-ue-resultat-recherche-municipalite-ue').val();
                    var municipaliteSelect = $('#contenu').find('.step-pane.active').find('#municipalite');
                    if (municipaliteSelect.length && municipaliteSelect.select2("val") != municipaliteUeResultat) {
                        municipaliteSelect.select2("val", municipaliteUeResultat);
                        municipaliteSelect.trigger('change');
                    }
                }

                $('#div-resultat').off('click', 'button').on('click', 'button', function () {

                    var id = $(this).attr('id');
                    if (response.length != 0) {
                        var element = "#" + id.replace("-x", "") + "_div";
                    }

                    $(this).closest(element).remove();
                    $('#exp-ue-recherche-nb').text($('#div-resultat > div').length + ' élément(s)');

                    $('.banniere').remove(); //pour eviter de desactiver la close de la banniere

                    return false;
                });
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                //$('#aucun-resultat').html('').append(getBanniereMessage('', 'Aucune propriété ne correspond à votre recherche.'));
                $('#exp-ue-recherche-nb').text('Aucune propriété ne correspond à votre recherche.');
                $('#exp-ue-recherche-nb').addClass("red");
            }
        });

    } else {
        //$('#aucun-resultat').html('').append(getBanniereMessage('', 'Aucune propriété ne correspond à votre recherche.'));
        $('#exp-ue-recherche-nb').text('Aucune propriété ne correspond à votre recherche.');
        $('#exp-ue-recherche-nb').addClass("red");
    }
}

function viderInfosMutation() {
    $('#exp-ue-lots').html('');
    $('#accordion-mutation-lots-ue-impliques').find('#checkbox-ue-lot-tous').prop("checked", false);
    $('#mutation-multiples-ues').html('');
    $('#accordion-mutation-multiples-ues').find('#checkbox-multiples-ues-tous').prop("checked", false);
    erreursAjax.effacerErreurChamps($('#localisation-ue-resultat-recherche-mutation'));
    $("#afficher-warning-cadastre-vertical-etape-2").hide();
}
